<template>
  <span
    class="label font-weight-bold label-lg label-inline label-light-success"
    style="width: max-content"
  >{{ getMerchantName() }}</span
  >
</template>

<script>
export default {
  props: ['merchantId'],
  data() {
    return {};
  },
  methods: {
    getMerchantName() {
      return process.env.VUE_APP_MERCHANT_CODE;
    },
  },
};
</script>
